/* ==========================================
   文件: assets/product-media-modals.js
   描述: 独立多媒体弹窗组件逻辑
========================================== */
document.addEventListener('DOMContentLoaded', function() {
    const initInterval = setInterval(() => {
      if (typeof Swiper !== 'undefined') {
        clearInterval(initInterval);
        initLightbox();
        initMediaExplorer();
      }
    }, 100);
  
    function initLightbox() {
      const lightbox = document.getElementById('GalleryLightbox');
      if (!lightbox) return;
  
      const lightboxSwiper = new Swiper('.lightbox-swiper', {
        loop: false, speed: 400, spaceBetween: 20,
        navigation: { nextEl: '.lightbox-nav-btn.next', prevEl: '.lightbox-nav-btn.prev' }
      });
  
      // 暴露为全局函数，方便其他板块（如画廊主图）跨组件调用
      window.openGalleryLightbox = function(index) {
        lightbox.classList.add('is-active');
        document.body.style.overflow = 'hidden'; 
        lightboxSwiper.slideTo(index, 0);
      };
  
      function closeLightbox() {
        lightbox.classList.remove('is-active');
        document.body.style.overflow = ''; 
        lightbox.querySelectorAll('video').forEach(vid => vid.pause());
        lightbox.querySelectorAll('iframe').forEach(iframe => { iframe.src = iframe.src; });
      }
  
      const lbCloseBtn = lightbox.querySelector('.lightbox-close-btn');
      if (lbCloseBtn) lbCloseBtn.addEventListener('click', closeLightbox);
      
      lightbox.querySelector('.lightbox-swiper').addEventListener('click', function(e) {
        if (e.target.classList.contains('swiper-slide')) { closeLightbox(); }
      });
  
      // 为防跨组件报错，这里只在主画廊存在时才绑定点击放大的事件
      const wrappers = document.querySelectorAll('.gallery-container .swiper-slide.media-wrapper');
      wrappers.forEach((wrapper, index) => {
        wrapper.addEventListener('click', function(e) {
          if (e.target.closest('.interactive-media') || e.target.closest('.main-nav-btn')) return;
          window.openGalleryLightbox(index);
        });
      });
  
      const zoomBtn = document.querySelector('.gallery-container .zoom-indicator-btn');
      if (zoomBtn) { 
        zoomBtn.addEventListener('click', () => { 
          const mainSwiperEl = document.querySelector('.main-swiper');
          let activeIndex = 0;
          if(mainSwiperEl && mainSwiperEl.swiper) activeIndex = mainSwiperEl.swiper.activeIndex;
          window.openGalleryLightbox(activeIndex); 
        }); 
      }
    }
  
    function initMediaExplorer() {
      const explorerOverlay = document.getElementById('V2MediaExplorer');
      if (!explorerOverlay) return;
      document.body.appendChild(explorerOverlay); // 提层防遮挡
      
      const closeBtn = explorerOverlay.querySelector('.v2-exp-close');
      const triggerBtns = document.querySelectorAll('[data-exp-target]');
      const navLinks = explorerOverlay.querySelectorAll('[data-exp-link]');
      const panes = explorerOverlay.querySelectorAll('.exp-pane');
      const swiperInstances = {};
  
      panes.forEach(pane => {
        const swiperEl = pane.querySelector('.exp-main-swiper');
        if (!swiperEl) return;
        const targetID = pane.id.replace('exp-pane-', '');
        const thumbs = pane.querySelectorAll('.exp-thumb-item');
  
        swiperInstances[targetID] = new Swiper(swiperEl, {
          loop: false, speed: 400, spaceBetween: 20,
          on: {
            slideChange: function () {
              thumbs.forEach(t => t.classList.remove('is-active'));
              if (thumbs[this.activeIndex]) {
                thumbs[this.activeIndex].classList.add('is-active');
                thumbs[this.activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }
              pane.querySelectorAll('video').forEach(v => v.pause());
              const activeSlide = this.slides[this.activeIndex];
              if(activeSlide) {
                const activeVideo = activeSlide.querySelector('video');
                if (activeVideo) activeVideo.play();
              }
            }
          }
        });
  
        thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', () => { swiperInstances[targetID].slideTo(index); });
        });
      });
  
      // const switchTab = (targetID) => {
      //   panes.forEach(pane => {
      //     if (pane.id === `exp-pane-${targetID}`) {
      //       pane.classList.add('is-active');
      //       if(swiperInstances[targetID]) swiperInstances[targetID].update();
      //     } else {
      //       pane.classList.remove('is-active');
      //       pane.querySelectorAll('video').forEach(v => v.pause());
      //     }
      //   });
      //   explorerOverlay.querySelectorAll('.exp-tab-btn').forEach(btn => {
      //     if (btn.getAttribute('data-exp-link') === targetID) btn.classList.add('is-active');
      //     else btn.classList.remove('is-active');
      //   });
      // };
      const switchTab = (targetID) => {
        panes.forEach(pane => {
          if (pane.id === `exp-pane-${targetID}`) {
            pane.classList.add('is-active');
            
            /* Delay Swiper update to allow browser paint, preventing layout thrashing/flickering */
            setTimeout(() => {
              if(swiperInstances[targetID]) {
                swiperInstances[targetID].update();
              }
            }, 50);
            
          } else {
            pane.classList.remove('is-active');
            pane.querySelectorAll('video').forEach(v => v.pause());
          }
        });
        
        explorerOverlay.querySelectorAll('.exp-tab-btn').forEach(btn => {
          if (btn.getAttribute('data-exp-link') === targetID) {
            btn.classList.add('is-active');
          } else {
            btn.classList.remove('is-active');
          }
        });
      };
  
      triggerBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          switchTab(btn.getAttribute('data-exp-target'));
          explorerOverlay.classList.add('is-active');
          document.body.style.overflow = 'hidden'; 
        });
      });
  
      navLinks.forEach(link => {
        link.addEventListener('click', () => { switchTab(link.getAttribute('data-exp-link')); });
      });
  
      const closeExplorer = () => {
        explorerOverlay.classList.remove('is-active');
        document.body.style.overflow = '';
        explorerOverlay.querySelectorAll('video').forEach(v => v.pause());
      };
  
      if (closeBtn) closeBtn.addEventListener('click', closeExplorer);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && explorerOverlay.classList.contains('is-active')) { closeExplorer(); }
      });
    }
});